import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { Providers } from './Providers.tsx';
import { App } from './app.tsx';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './styles.css';
import { initTime } from '@libs/intl/time.ts';
import { ScrollbarStyles } from '@atoms/layout';
import { MUI_LICENSE_KEY } from '@libs/config';
import { LicenseInfo } from '@mui/x-license';
import { initDayJsPlugins } from './libs/dayjs';
import { great } from '@libs/logger';

great();
LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

initDayJsPlugins();

initTime();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <CssBaseline />
      <ScrollbarStyles />
      <App />
    </Providers>
  </React.StrictMode>,
);
